import { useState } from 'react';

function stringify(value) {
  if (typeof value === 'string') return value;
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}

// Collapsible pretty-printed JSON with a copy button. Renders nothing for empty values.
export default function JsonBlock({ label = 'Details', value, defaultOpen = false }) {
  const [copied, setCopied] = useState(false);

  if (value == null || value === '') return null;
  const text = stringify(value);

  function handleCopy(e) {
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard?.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }).catch(() => {});
  }

  return (
    <details className="gc-json" open={defaultOpen}>
      <summary className="gc-json-summary">
        <span>{label}</span>
        <button type="button" className="gc-json-copy" onClick={handleCopy}>
          {copied ? 'Copied' : 'Copy'}
        </button>
      </summary>
      <pre className="gc-json-pre">{text}</pre>
    </details>
  );
}
